import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
type HueCircleStyle = {
  deg: number;
  hue1: number;
  hue2: number;
  hue3: number;
};
export type { HueCircleStyle };
type Props = Partial<HueCircleStyle>;
const HUE_CIRCLE_DEGREES = [45, 135, 225, 315];
function hashString(value: string): number {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash;
}

/** Deterministic gradient colors for a stable seed (e.g. organization id). */
export function getHueCircleStyleFromSeed(seed: string): HueCircleStyle {
  const hash = hashString(seed);
  const absHash = Math.abs(hash);
  return {
    deg: HUE_CIRCLE_DEGREES[absHash % HUE_CIRCLE_DEGREES.length],
    hue1: absHash % 360,
    hue2: Math.abs(hash * 31) % 360,
    hue3: Math.abs(hash * 127) % 360
  };
}
export function getHueCircleBackground(style: HueCircleStyle): string {
  return `linear-gradient(${style.deg}deg, hsl(${style.hue1}, 100%, 70%), hsl(${style.hue2}, 100%, 70%), hsl(${style.hue3}, 100%, 70%))`;
}

/** Middle stop of the gradient, softened: an outline can only take one color. */
export function getHueCircleOutlineColor(style: HueCircleStyle): string {
  return `hsl(${style.hue2} 100% 70% / 0.7)`;
}
export function RandomHueCircle(t0) {
  const $ = _c(7);
  const {
    deg,
    hue1,
    hue2,
    hue3
  } = t0;
  const defaultDeg = Math.floor(Math.random() * 360);
  const defaultHue1 = Math.floor(Math.random() * 360);
  const defaultHue2 = Math.floor(Math.random() * 360);
  const defaultHue3 = Math.floor(Math.random() * 360);
  const t1 = deg ?? defaultDeg;
  const t2 = hue1 ?? defaultHue1;
  const t3 = hue2 ?? defaultHue2;
  const t4 = hue3 ?? defaultHue3;
  let t5;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = getHueCircleBackground({
      deg: t1,
      hue1: t2,
      hue2: t3,
      hue3: t4
    });
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t5) {
    t6 = <div className="aspect-square w-3.5 rounded-full" style={{
      background: t5
    }} />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}